import * as React from 'react'
import { connect } from 'react-redux'
import Navigator from '../../app/navigator'
import { ApplicationState } from '../../redux/ApplicationState'

interface OwnProps {
    label: string
    sortKey: string
    currentSortKey: string
}

interface StateProps {
    navigator: Navigator
}

type Props = StateProps & OwnProps

class SortableColumnHeader extends React.Component<Props> {
    public render() {
        const { currentSortKey, sortKey, label, navigator } = this.props

        return currentSortKey === sortKey ? (
            <span className="text-underline">
                {label}
                <i className="fa fa-sort-desc tw-ml-4 tw-color-grey-500" />
            </span>
        ) : (
            <a onClick={() => navigator.replace({ sort: sortKey })}>{label}</a>
        )
    }
}

export default connect<StateProps, {}, {}>((globalState: ApplicationState, props) => {
    return {
        navigator: new Navigator(globalState.tidewaysContext.route),
    }
}, {})(SortableColumnHeader)
